import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import {
  DataGridContainer,
  FullDivider,
  TypographyLink,
} from '../../../../../ui/styled';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { ORGANIZATION_SAP_INVOICES_ACTIVITIES_LIST_URL } from '../../../../../../constants';
import {
  GridContainer,
  LeftGrid,
  NoteHeading,
} from '../../../../../Episode/Episode.Styled';
import {
  getOrganizationSapActivitiesContactForm,
  newOrganizationSapActivitiesContactForm,
} from '../../../../../../redux/organization/organizationTabs/organizationSap/organizationSapActivitiesContacts/organizationSapActivitiesContactsSlice';
import { getSapActivitiesAndInvoicesList } from './services/sapListApi';
import SapActivitiesDialog from './SapActivityDialog/SapActivityDialog';

const SapActivityList = (props) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [openSapActivitiesDialog, setOpenSapActivitiesDialog] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [sapList, setSapList] = useState({
    isLoading: false,
    sapActivitiesListData: [],
    sapInvoicesListData: [],
    total: 0,
    // page: 1,
    // pageSize: 10,
    // sortModel: '',
  });

  const organizationForm = useSelector((state) => state.organizationForm);
  const { orgId } = organizationForm;

  const organizationReferenceData = useSelector(
    (state) => state.organizationReferenceData
  );
  const { contactKeyList, phoneList, faxList } = organizationReferenceData;

  const searchItem = (searchKey, searchList, returnValueKey) => {
    const searchItem = searchList.find((item) => item.id === searchKey);
    return searchItem[returnValueKey];
  };
  const getContactName = (contactId) => {
    return searchItem(contactId, contactKeyList, 'value');
  };
  const getContactPhone = (contactId) => {
    return searchItem(contactId, phoneList, 'value');
  };
  const getContactFax = (contactId) => {
    return searchItem(contactId, faxList, 'value');
  };

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const fetchData = async () => {
    setSapList((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${ORGANIZATION_SAP_INVOICES_ACTIVITIES_LIST_URL}/${orgId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const sapActivitiesAndinvoices = await getSapActivitiesAndInvoicesList({
      commonParams,
      authorization,
      getContactName,
      getContactPhone,
      getContactFax,
    });
    setSapList((prveState) => ({
      ...prveState,
      ...sapActivitiesAndinvoices,
    }));
  };

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const updateSapContact = (params) => {
    const { row } = params;
    const sapContact = {
      orgCntId: row?.orgCntId,
      contactKey: row?.contactKey,
      contactKeyId: row?.contactKeyId,
      phone: row?.phone,
      fax: row?.fax,
    };
    dispatch(getOrganizationSapActivitiesContactForm(sapContact));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 1000);
    setOpenSapActivitiesDialog(true);
  };

  const handelNewOrganizationSapContactForm = () => {
    const newOrganizationSapContactForm = {
      newOrganizationSapActivitiesForm: true,
      orgId: orgId,
      orgCntId: 0,
      contactKey: null,
      contactKeyId: null,
      phone: null,
      fax: null,
    };
    dispatch(
      newOrganizationSapActivitiesContactForm(newOrganizationSapContactForm)
    );
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 1000);
    setOpenSapActivitiesDialog(true);
  };

  const sapActivitiesColumnsData = [
    {
      field: 'contactKey',
      headerName: 'Contact Key',
      renderCell: (params) => {
        return (
          <TypographyLink variant='h6' onClick={() => updateSapContact(params)}>
            {params.row.contactKey}
          </TypographyLink>
        );
      },
      flex: 1,
    },
    { field: 'phone', headerName: 'Phone', flex: 1 },
    { field: 'fax', headerName: 'Fax', flex: 1 },
  ];

  const sapInvoicesColumnsData = [
    { field: 'invId', headerName: 'InvId', flex: 1 },
    { field: 'date', headerName: 'Date', type: 'date', flex: 1 },
    { field: 'dateCreated', headerName: 'Date Created', type: 'date', flex: 1 },
    { field: 'dateSent', headerName: 'Date Sent', type: 'date', flex: 1 },
    { field: 'dateStart', headerName: 'Date Start', type: 'date', flex: 1 },
    { field: 'amount', headerName: 'Amount', flex: 1 },
  ];

  const getTitleAndButton = () => {
    return (
      <>
        <FullDivider />
        <GridContainer container>
          <Grid item xs={6}>
            <NoteHeading variant='h5'>
              SAP Activity Report Fax to Contact
            </NoteHeading>
          </Grid>
          <LeftGrid item xs={6}>
            <Button
              variant='contained'
              onClick={() => handelNewOrganizationSapContactForm()}
            >
              New Sap Contact
            </Button>
          </LeftGrid>
        </GridContainer>
      </>
    );
  };

  const getActivitiesDataGrid = () => {
    return (
      <DataGridContainer>
        <DataGrid
          getRowHeight={() => 'auto'}
          columns={sapActivitiesColumnsData}
          rows={sapList.sapActivitiesListData}
          // pageSize={contactList.pageSize}
          // page={contactList.page - 1}
          rowCount={sapList.total}
          getRowId={(row) => row._id}
          // paginationMode='server'
          // sortingMode='server'
          // onPageSizeChange={(newPageSize) =>
          //   setContactList((old) => ({ ...old, pageSize: newPageSize }))
          // }
          // onPageChange={(newPage) => {
          //   setContactList((old) => ({ ...old, page: newPage + 1 }));
          // }}
          // rowsPerPageOptions={paginationSize}
          //pagination
          //components={{ Toolbar: QuickSearchToolbar }}
          experimentalFeatures={{ newEditingApi: true }}
          //onSortModelChange={handleSortModelChange}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          loading={sapList.isLoading}
        />
      </DataGridContainer>
    );
  };

  const getTitle = () => {
    return (
      <>
        <FullDivider />
        <GridContainer container>
          <Grid item xs={6}>
            <NoteHeading variant='h5'>SAP Invoices</NoteHeading>
          </Grid>
          <LeftGrid item xs={6}></LeftGrid>
        </GridContainer>
      </>
    );
  };

  const getInvoicesDataGrid = () => {
    return (
      <DataGridContainer>
        <DataGrid
          getRowHeight={() => 'auto'}
          columns={sapInvoicesColumnsData}
          rows={sapList.sapInvoicesListData}
          // pageSize={contactList.pageSize}
          // page={contactList.page - 1}
          rowCount={sapList.total}
          getRowId={(row) => row._id}
          // paginationMode='server'
          // sortingMode='server'
          // onPageSizeChange={(newPageSize) =>
          //   setContactList((old) => ({ ...old, pageSize: newPageSize }))
          // }
          // onPageChange={(newPage) => {
          //   setContactList((old) => ({ ...old, page: newPage + 1 }));
          // }}
          // rowsPerPageOptions={paginationSize}
          //pagination
          //components={{ Toolbar: QuickSearchToolbar }}
          experimentalFeatures={{ newEditingApi: true }}
          //onSortModelChange={handleSortModelChange}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          loading={sapList.isLoading}
        />
      </DataGridContainer>
    );
  };

  const getSapActivitiesDialog = () => {
    return (
      <>
        <SapActivitiesDialog
          open={openSapActivitiesDialog}
          setOpen={setOpenSapActivitiesDialog}
          authToken={user?.signInUserSession.accessToken.jwtToken}
          openBackdrop={openBackdrop}
          orgId={orgId}
          fetchData={fetchData}
        />
      </>
    );
  };

  return (
    <>
      {getTitleAndButton()}
      {getActivitiesDataGrid()}
      {getTitle()}
      {getInvoicesDataGrid()}
      {getSapActivitiesDialog()}
    </>
  );
};

export default SapActivityList;
